import { useSteleStore, SteleView } from '@/state/store';
import { i18n, Lang } from '@/i18n/dict';

const STATES: { id: SteleView; label: string }[] = [
  { id: 'idle-orb', label: 'Idle (Orb)' },
  { id: 'idle-content', label: 'Idle (Content)' },
  { id: 'calling', label: 'Calling' },
  { id: 'incall', label: 'In-Call' },
  { id: 'waiting', label: 'Waiting' },
  { id: 'unavailable', label: 'Unavailable' },
  { id: 'feedback', label: 'Feedback' },
  { id: 'goodbye', label: 'Goodbye' },
];

const LANGS: Lang[] = ['de', 'en', 'tr', 'ar'];

export function StateHarness() {
  const view = useSteleStore((s) => s.view);
  const setView = useSteleStore((s) => s.setView);
  const lang = useSteleStore((s) => s.lang);
  const setLang = useSteleStore((s) => s.setLang);
  const toggleTranslation = useSteleStore((s) => s.toggleTranslation);
  const openLangOverlay = useSteleStore((s) => s.openLangOverlay);
  const openConsent = useSteleStore((s) => s.openConsent);

  // Mock-V2-Cockpit-Leiste nur im Dev-Modus zeigen
  const dev = new URLSearchParams(window.location.search).get('dev') === '1';
  if (!dev) return null;

  return (
    <>
      <div className="harness-top">
        <div className="brand-mark">BAMOA STELE · V2 · OPERATING-ROOM CALM</div>
        <div className="lang-switcher">
          {LANGS.map((l) => (
            <button key={l} className={lang === l ? 'active' : ''} onClick={() => setLang(l)}>
              {l === 'ar' ? 'AR (RTL)' : l.toUpperCase()}
            </button>
          ))}
        </div>
      </div>
      <div className="harness-bottom">
        <div className="toggle-row">
          <span className="label">In-Call Layer:</span>
          <button className="toggle-chip" onClick={toggleTranslation}>
            🌐 Übersetzung
          </button>
          <button className="toggle-chip" onClick={openLangOverlay}>
            🇹🇷 Sprachauswahl
          </button>
          <button className="toggle-chip" onClick={() => openConsent()}>
            ⏺ Aufzeichnungs-Consent
          </button>
        </div>
        <div className="label">State-Wechsel</div>
        <div className="state-switcher">
          {STATES.map((s) => (
            <button key={s.id} className={view === s.id ? 'active' : ''} onClick={() => setView(s.id)}>
              {s.label}
            </button>
          ))}
        </div>
      </div>
    </>
  );
}
